/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Linked_FilterInputs */

const vi_shop_account_linked_filter = /** @type {(inputs: Shop_Account_Linked_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết KH ERP`)
};

/**

* @param {Shop_Account_Linked_FilterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_linked_filter = /** @type {((inputs?: Shop_Account_Linked_FilterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Linked_FilterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_linked_filter(inputs)
});